module.exports = __webpack_public_path__ + "static/img/bc-zqj.2718af3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-zqj.png
// module id = S0NW
// module chunks = 0